import createIcon from '../../createIcon';

/**
 * @component @name ContentCopy
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAxSDQuNUMzLjQgMSAyLjUgMS45IDIuNSAzVjE3SDQuNVYzSDE2LjVWMVpNMTkuNSA1SDguNUM3LjQgNSA2LjUgNS45IDYuNSA3VjIxQzYuNSAyMi4xIDcuNCAyMyA4LjUgMjNIMTkuNUMyMC42IDIzIDIxLjUgMjIuMSAyMS41IDIxVjdDMjEuNSA1LjkgMjAuNiA1IDE5LjUgNVpNMTkuNSAyMUg4LjVWN0gxOS41VjIxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ContentCopy = createIcon('ContentCopy', [
  [
    'path',
    {
      d: 'M16.5 1H4.5C3.4 1 2.5 1.9 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.4 5 6.5 5.9 6.5 7V21C6.5 22.1 7.4 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.9 20.6 5 19.5 5ZM19.5 21H8.5V7H19.5V21Z',
      key: '1cs8dm',
    },
  ],
]);

export default ContentCopy;
